import { createSlice } from '@reduxjs/toolkit';

/**
 * Pending changes detected in the DJ apps' libraries (main-process watcher,
 * see backend/djLibraryWatcher.js). `pending[app]` = { label, summary, diff,
 * at } while the user hasn't synced yet; the rail dot, the in-app card and
 * the sidebar banner all read from here. `syncRequested[app]` is a one-shot
 * flag set by "Sync now" affordances outside the app's sidebar (toast card,
 * OS notification) — the sidebar picks it up on mount and runs its import.
 */
const djLibraryChangesSlice = createSlice({
    name: 'djLibraryChanges',
    initialState: {
        pending: {},
        syncRequested: {},
    },
    reducers: {
        setAllPending(state, action) {
            state.pending = action.payload || {};
        },
        setPending(state, action) {
            const { app, change } = action.payload;
            if (change) state.pending[app] = change;
            else delete state.pending[app];
        },
        requestSync(state, action) {
            state.syncRequested[action.payload] = true;
        },
        clearSyncRequest(state, action) {
            delete state.syncRequested[action.payload];
        },
        // Account switch/logout (authThunk.wipeUserScopedState): the pending
        // diffs describe the PREVIOUS account's sync relationships — for a
        // new account they'd render an unexplainable rail dot (the banner
        // that explains it only shows in a synced sidebar).
        clearDjLibraryChanges(state) {
            state.pending = {};
            state.syncRequested = {};
        },
    },
});

export const { setAllPending, setPending, requestSync, clearSyncRequest, clearDjLibraryChanges } = djLibraryChangesSlice.actions;
export default djLibraryChangesSlice.reducer;
